import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Instagram, Globe } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function ContactSection() {
  const {
    t
  } = useLanguage();
  return <section id="contacto" className="py-16 sm:py-20 md:py-32 px-4 sm:px-6 bg-sage-lighter/10 relative" data-id="element-70">
      <div className="max-w-6xl mx-auto" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-10 sm:mb-16" data-id="element-72">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-forest-dark mb-5 sm:mb-6 uppercase leading-tight" data-id="element-73">
            {t('contact.title')}
          </h2>
          <div className="w-16 h-[1px] bg-terracotta mx-auto" data-id="element-74"></div>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-start" data-id="element-75">
          {/* Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-2 space-y-6 sm:space-y-8" data-id="element-76">
            <h3 className="text-xl sm:text-2xl font-serif text-forest-dark" data-id="element-77">
              {t('contact.name')}
            </h3>

            <div className="space-y-4 sm:space-y-6 text-forest/80" data-id="element-78">
              <a href="tel:671636887" className="flex items-center gap-3 sm:gap-4 hover:text-gold-dark transition-colors min-w-0" data-id="element-79">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white flex items-center justify-center shadow-sm text-forest flex-shrink-0" data-id="element-80">
                  <Phone className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-81" />
                </div>
                <span className="text-base sm:text-lg" data-id="element-82">671 636 887</span>
              </a>
              <a href="mailto:georginaconstelaciones@gmail.com" className="flex items-center gap-3 sm:gap-4 hover:text-gold-dark transition-colors min-w-0" data-id="element-83">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white flex items-center justify-center shadow-sm text-forest flex-shrink-0" data-id="element-84">
                  <Mail className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-85" />
                </div>
                <span className="text-sm sm:text-lg break-all min-w-0" data-id="element-86">
                  georginaconstelaciones@gmail.com
                </span>
              </a>
              <a href="https://instagram.com/georgina_constelaciones" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 sm:gap-4 hover:text-gold-dark transition-colors min-w-0" data-id="element-87">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white flex items-center justify-center shadow-sm text-forest flex-shrink-0" data-id="element-88">
                  <Instagram className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-89" />
                </div>
                <span className="text-base sm:text-lg break-all" data-id="element-90">
                  @georgina_constelaciones
                </span>
              </a>
              <a href="https://www.georginaconstelaciones.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 sm:gap-4 hover:text-gold-dark transition-colors min-w-0" data-id="element-91">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white flex items-center justify-center shadow-sm text-forest flex-shrink-0" data-id="element-92">
                  <Globe className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-93" />
                </div>
                <span className="text-base sm:text-lg break-all" data-id="element-94">
                  www.georginaconstelaciones.com
                </span>
              </a>
            </div>
          </motion.div>

          {/* Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-3 bg-white/80 backdrop-blur-sm rounded-[1.5rem] sm:rounded-[2.5rem] md:rounded-[3rem] p-5 sm:p-8 md:p-12 shadow-soft border border-sage-light/30" data-id="element-95">
            <p className="text-lg sm:text-xl font-serif text-forest-dark mb-6 sm:mb-8 italic" data-id="element-96">
              {t('contact.form_title')}
            </p>

            <form className="space-y-4 sm:space-y-6" onSubmit={e => e.preventDefault()} data-id="element-97">
              <div data-id="element-98">
                <input type="text" placeholder={t('contact.f_name')} required className="w-full bg-sage-lighter/20 border border-sage-light/50 rounded-xl px-4 sm:px-6 py-3 sm:py-4 text-forest text-sm sm:text-base focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-all" data-id="element-99" />
              </div>
              <div className="grid sm:grid-cols-2 gap-4 sm:gap-6" data-id="element-100">
                <input type="tel" placeholder={t('contact.f_phone')} required className="w-full bg-sage-lighter/20 border border-sage-light/50 rounded-xl px-4 sm:px-6 py-3 sm:py-4 text-forest text-sm sm:text-base focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-all" data-id="element-101" />
                <input type="email" placeholder={t('contact.f_email')} required className="w-full bg-sage-lighter/20 border border-sage-light/50 rounded-xl px-4 sm:px-6 py-3 sm:py-4 text-forest text-sm sm:text-base focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-all" data-id="element-102" />
              </div>
              <div data-id="element-103">
                <textarea placeholder={t('contact.obs_placeholder')} rows={4} className="w-full bg-sage-lighter/20 border border-sage-light/50 rounded-xl px-4 sm:px-6 py-3 sm:py-4 text-forest text-sm sm:text-base focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-all resize-none placeholder:text-forest/40" data-id="element-104"></textarea>
              </div>

              <div className="space-y-4" data-id="element-105">
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-106">
                  <input type="checkbox" required className="mt-1 w-5 h-5 rounded border-sage-light text-gold focus:ring-gold" data-id="element-107" />
                  <span className="text-sm text-forest/70 group-hover:text-forest transition-colors" data-id="element-108">
                    {t('contact.check2')}
                  </span>
                </label>
              </div>

              {/* reCAPTCHA Placeholder */}
              <div className="bg-gray-100 border border-gray-300 rounded p-3 sm:p-4 flex items-center justify-between gap-3 max-w-full overflow-hidden" data-id="element-109">
                <div className="flex items-center gap-2 sm:gap-3 min-w-0" data-id="element-110">
                  <input type="checkbox" className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" data-id="element-111" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-112">
                    I'm not a robot
                  </span>
                </div>
                <div className="flex flex-col items-center flex-shrink-0" data-id="element-113">
                  <img src="https://www.gstatic.com/recaptcha/api2/logo_48.png" alt="reCAPTCHA" className="w-7 sm:w-8" data-id="element-114" />
                  <span className="text-[9px] sm:text-[10px] text-gray-500 mt-1" data-id="element-115">
                    reCAPTCHA
                  </span>
                  <div className="text-[8px] text-gray-500 flex gap-1" data-id="element-116">
                    <span data-id="element-117">Privacy</span> - <span data-id="element-118">Terms</span>
                  </div>
                </div>
              </div>

              <button type="submit" className="w-full py-3 sm:py-4 bg-gold text-forest-dark text-sm sm:text-base font-bold tracking-widest uppercase rounded-xl hover:bg-gold-light transition-colors shadow-md" data-id="element-119">
                {t('contact.submit')}
              </button>
            </form>

            <div className="mt-6 sm:mt-8 pt-5 sm:pt-6 border-t border-sage-lighter/50 flex flex-wrap justify-center gap-3 sm:gap-4 text-xs text-forest/50" data-id="element-120">
              <a href="#" className="hover:text-forest transition-colors" data-id="element-121">
                {t('contact.legal')}
              </a>
              <span data-id="element-122">|</span>
              <a href="#" className="hover:text-forest transition-colors" data-id="element-123">
                {t('contact.privacy')}
              </a>
              <span data-id="element-124">|</span>
              <a href="#" className="hover:text-forest transition-colors" data-id="element-125">
                {t('contact.cookies')}
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}